<!-- Agent name ────────────────────────────────────────────────── -->
<td class="tutor-row__cell-name">
  <div class="tutor-row__name-line">
    <strong class="tutor-row__identity-name">{{ tutor.name }}</strong>
  </div>
</td>

<!-- KB column: read-only course-sync status + agent KB multi-select ─ -->
<td class="tutor-row__cell-kb">
  <div
    class="tutor-row__linked-control tutor-row__linked-control--kb"
    [class.has-sync-badge]="hasMoodlePlacements"
  >
    <span
      *ngIf="hasMoodlePlacements"
      class="tutor-row__sync-badge"
      [class.is-active]="syncedPlacementCount > 0"
      [attr.title]="'pages.tutors.placements.kb.courseSyncBadgeHint' | translate"
    >
      <span class="tutor-row__sync-dot"></span>
      <span>
        {{ 'pages.tutors.placements.kb.courseSyncBadge' | translate:{
          synced: syncedPlacementCount,
          total: totalPlacementCount
        } }}
      </span>
    </span>
    <span *ngIf="hasMoodlePlacements" class="tutor-row__connector" aria-hidden="true"></span>
    <nb-select
      class="tutor-row__select"
      multiple
      [ngModel]="kbIds"
      (ngModelChange)="onKbIdsChange($event)"
      [placeholder]="'pages.tutors.placements.kb.kbPlaceholder' | translate"
      [nbTooltip]="'pages.tutors.placements.kb.additionalKbsLabel' | translate"
      nbTooltipPlacement="top"
      fullWidth
    >
      <nb-option *ngFor="let ds of kbDataSources" [value]="ds.id">
        <span class="tutor-row__kb-option">
          <span class="tutor-row__kb-option-name">{{ ds | knowledgeSourceName | async }}</span>
          <span
            *ngIf="isAutoBucketDataSource(ds.id)"
            class="tutor-row__kb-option-meta"
          >
            {{ 'pages.tutors.placements.kb.courseSyncOption' | translate }}
          </span>
        </span>
      </nb-option>
    </nb-select>
  </div>
</td>

<!-- Dozent column ────────────────────────────────────────────── -->
<td class="tutor-row__cell-dozent">
  <div class="tutor-row__linked-control tutor-row__linked-control--dozent">
    <nb-toggle
      class="tutor-row__dozent-toggle"
      [checked]="dozentEnabled"
      (checkedChange)="onDozentToggle($event)"
      [nbTooltip]="'pages.tutors.placements.kb.dozentToggle' | translate"
      nbTooltipPlacement="top"
    ></nb-toggle>
    <span class="tutor-row__connector" aria-hidden="true"></span>
    <nb-select
      class="tutor-row__select"
      [ngModel]="dozentBotId"
      (ngModelChange)="onDozentBotChange($event)"
      [placeholder]="'pages.tutors.placements.kb.dozentPlaceholder' | translate"
      [disabled]="!dozentEnabled"
      fullWidth
    >
      <nb-option *ngFor="let d of dozentBots" [value]="d.id">
        {{ d.name }}
      </nb-option>
    </nb-select>
  </div>
</td>

<!-- Save action ──────────────────────────────────────────────── -->
<td class="tutor-row__cell-actions">
  <button
    nbButton
    size="small"
    status="primary"
    [disabled]="!dirty || saving || loading"
    (click)="save()"
  >
    <nb-icon *ngIf="saving" icon="loader-outline" class="spin"></nb-icon>
    {{ 'pages.tutors.placements.save' | translate }}
  </button>
</td>
